// src/utils/transportIcons.jsx
import React from "react";
import { Tooltip } from "@mui/material";
import { Bus, Car } from "lucide-react";

const TRANSPORT_ICONS = {
  "eco-bus": { Icon: Bus, title: "Bussikokonaisuus" },
  "eco-bus": { Icon: Bus, title: "Bussi" },
  "express": { Icon: Car, title: "Pikakuljetus" },
};

/**
 * Returns a Tooltip-wrapped transport icon for the given deliveryTransportType,
 * or null if the type has no icon configured.
 *
 * @param {string} type  - delivery.deliveryTransportType
 * @param {number} size  - icon size in px (default 12)
 */
export function getTransportIcon(type, size = 20) {
  const cfg = TRANSPORT_ICONS[type];
  if (!cfg) return null;
  const { Icon, title } = cfg;
  return (
    <Tooltip title={title} arrow>
      <Icon size={size} opacity={0.55} />
    </Tooltip>
  );
}